import DatabaseMockService from "./Mock/databaseMockService";
import DatabaseService from "./Server/databaseService";

const useMockServices = true;   //TODO to config

export const databaseService = useMockServices
    ? new DatabaseMockService()
    : new DatabaseService();
